import React, { useEffect } from 'react'
import { isUserActive, oldVersion, userUid } from '../utils/storage';
import UserCheckService from '../GlobalSetupComponents/Services/UserCheckService';
import { useNavigate } from 'react-router-dom';

const useUserStatusCheck = () => {

    const navigate = useNavigate();


  const handleSignout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const fetchUserStatus = async () => {
    try {
    
      if (!userUid) {
        console.log("No userUid available for status check");
        return;
      }

      console.log("Checking user status for UID:", userUid);
      
      const body = {
        uid: userUid,
      };
      const response = await UserCheckService.isUserActive(body);
      const data = response.data;
      
      if (data) {
        localStorage.setItem("userActiveDetails", JSON.stringify(data));
        const newVersion = data?.webVersion;
        const currentVersion = oldVersion ;
        const isVersionMatch = newVersion === currentVersion;
        const isUserActiveStatus = data?.userStatus === "active";

        // console.log("User status check results:");
        // console.log("- Web version (new):", newVersion);
        // console.log("- Web version (old):", currentVersion);
        // console.log("- User status:", data?.userStatus);
        // console.log("- Is user active:", isUserActiveStatus);
        // console.log("- Is version up-to-date:", isVersionMatch);

        // Check if user is inactive or version doesn't match
        if(!isUserActiveStatus || !isVersionMatch){
          handleSignout();
        }
      } else {
        console.log("No data received from user status check");
        handleSignout();
      }
    } catch (error) {
      console.error("Error fetching user status:", error);
      console.error("Error details:", error.response?.data || error.message);
      

      console.log("Error occurred during status check, logging out existing client for fresh login");
    
    }
  };

  useEffect(() => {
    if (userUid) {

      const timeoutId = setTimeout(() => {
        fetchUserStatus();
      }, 1000); 

      return () => clearTimeout(timeoutId);
    }
  }, []);

  return (
<></>
  );
}

export default useUserStatusCheck